import React from "react";
import { observer } from "mobx-react";
import { useStores } from "../../stores/rootStore";
import { EmployeeReviewActions } from "../../stores/models/enums";
import { Checkbox, FormGroup, FormControlLabel, DialogActions, DialogContent, Button } from "@material-ui/core";
import QARFormHelper from "./helper";
import { ReviewEmployeeDto } from "src/stores/models/qarFormModels";

export const QARFormBulkReview = observer(({ isSystemAccounts }: { isSystemAccounts: boolean }) => {

    const { qarFormStore, uiStateStore } = useStores();

    const updateActionUponChangeEvent = (reviewEmployees: ReviewEmployeeDto[], employeesChanges: ReviewEmployeeDto[], isChecked: boolean) => {

        for (let i = 0; i < reviewEmployees.length; i++) {

            const accounts = reviewEmployees[i].accounts;

            const accountsChanges = employeesChanges[i].accounts;

            for (let j = 0; j < accounts.length; j++) {

                const action = accounts[j].action;

                const actionChanges = accountsChanges[j].action;

                if (isChecked) {
                    if (actionChanges.name === EmployeeReviewActions.MissingAction) {
                        actionChanges.name = EmployeeReviewActions.Approved;
                    }
                } else {
                    if (action.name === EmployeeReviewActions.MissingAction
                        && actionChanges.name === EmployeeReviewActions.Approved) {
                        actionChanges.name = EmployeeReviewActions.MissingAction;
                    }
                }
            }
        }
    };

    const confirmSave = (isSystemAccounts: boolean) => {

        isSystemAccounts ? bulkReviewsUnmatchedAccountsChange(true) : bulkReviewsMatchedAccountsChange(true);
        uiStateStore.clearModal();
    };

    const renderConfirmationDialogContent = (isSystemAccounts: boolean) => {

        return <div>
            <h2>Are you sure?</h2>
            <DialogContent dividers={true}>
                <p>When you click the "Select All" button, please note that it will select ALL users, not just the ones that are currently visible on the screen.</p>
                <p>This means that if you have multiple pages of users, all of them will be selected.</p>
                <p> Please confirm that you want to proceed with selecting all users before clicking the button</p>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => uiStateStore.clearModal()} color="primary">
                    Cancel
                </Button>
                <Button onClick={() => confirmSave(isSystemAccounts)} color="primary">
                    Confirm
                </Button>
            </DialogActions>
        </div>
    };

    const actionHandler = (isSystemAccounts: boolean, event: React.ChangeEvent<HTMLInputElement>) => {

        if (!event.target.checked) {
            isSystemAccounts ? bulkReviewsUnmatchedAccountsChange(false) : bulkReviewsMatchedAccountsChange(false);
        } else {
            uiStateStore.setModalContent(renderConfirmationDialogContent(isSystemAccounts))
            uiStateStore.setModalOpen(true)
        }
    };

    const bulkReviewsMatchedAccountsChange = (isChecked: boolean) => {

        if (qarFormStore.employees && qarFormStore.employeesChanges) {

            if (qarFormStore.bulkReviewIndeterminate) {
                qarFormStore.bulkReviewIndeterminate = false;
            }

            qarFormStore.bulkReviewChecked = !qarFormStore.bulkReviewChecked;

            updateActionUponChangeEvent(qarFormStore.employees, qarFormStore.employeesChanges, isChecked);
        }
    };

    const bulkReviewsUnmatchedAccountsChange = (isChecked: boolean) => {

        if (qarFormStore.delegatedUnmatchedAccounts && qarFormStore.delegatedUnmatchedAccountsChanges) {

            if (qarFormStore.unmatchedBulkReviewIndeterminate) {
                qarFormStore.unmatchedBulkReviewIndeterminate = false;
            }

            qarFormStore.unmatchedBulkReviewChecked = !qarFormStore.unmatchedBulkReviewChecked;

            updateActionUponChangeEvent(qarFormStore.delegatedUnmatchedAccounts, qarFormStore.delegatedUnmatchedAccountsChanges, isChecked);
        }
    };

    const renderBulkReviews = () => {

        if (!qarFormStore.shouldDisplayBulkReview) {
            return <></>;
        }

        let accounts = isSystemAccounts ?
            qarFormStore.delegatedUnmatchedAccounts?.flatMap(x => x.accounts) :
            qarFormStore.employees?.flatMap(x => x.accounts);

        if (!accounts) {
            return <></>
        }

        let checked = isSystemAccounts ?
            qarFormStore.unmatchedBulkReviewChecked :
            qarFormStore.bulkReviewChecked;

        let indeterminate = isSystemAccounts ?
            qarFormStore.unmatchedBulkReviewIndeterminate :
            qarFormStore.bulkReviewIndeterminate

        let disabled = QARFormHelper.masterBulkReviewDisabled(accounts)

        return (
            <FormGroup row>
                <FormControlLabel
                    style={{ marginLeft: '15px' }}
                    control={
                        <Checkbox
                            checked={checked}
                            indeterminate={indeterminate}
                            onChange={(e) => actionHandler(isSystemAccounts, e)}
                            disabled={disabled}
                            color={"primary"}
                            inputProps={{ 'aria-label': 'checkbox' }} />
                    }
                    label="Select all for approval"
                />
            </FormGroup>
        );
    };

    return (
        <>
            {renderBulkReviews()}
        </>
    );
});